(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["firework-embed"] && !Shopify.designMode) return;
  try {
    
  /* This function is required for the floating player and floating button.
  Shopify's page-builder places these DOM nodes in a weird way that blocks
  the static positioning from working properly. Moving the node to be a
  direct child of <body> makes it work properly. */

  var element = document.getElementById('move-to-body');
  if (element) {
    document.querySelector('body').appendChild(element);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-carousel"] && !Shopify.designMode) return;
  try {
    
(function () {
function init(root) {
if (root.dataset.rvcInit === '1') return;
root.dataset.rvcInit = '1';
var track = root.querySelector('[data-rvc-track]');
var viewport = root.querySelector('[data-rvc-viewport]');
if (!track || !viewport) return;
var W = 200, GAP = 24;
var doShuffle = root.dataset.shuffle === '1';
var max = parseInt(root.dataset.max, 10) || 0;
var base = Array.prototype.slice.call(track.querySelectorAll('[data-rvc-card]'));
if (!base.length) return;
base.forEach(function (n) { n.parentNode.removeChild(n); });
if (doShuffle) {
var pinned = [], rest = [];
base.forEach(function (node) {
var s = parseInt(node.getAttribute('data-sort'), 10);
if (isNaN(s)) rest.push(node); else pinned.push(node);
});
pinned.sort(function (a, b) { return parseInt(a.getAttribute('data-sort'), 10) - parseInt(b.getAttribute('data-sort'), 10); });
for (var i = rest.length - 1; i > 0; i--) {
var j = Math.floor(Math.random() * (i + 1));
var t = rest[i]; rest[i] = rest[j]; rest[j] = t;
}
base = pinned.concat(rest);
if (max > 0 && base.length > max) base = base.slice(0, max);
} else {
base.sort(function (a, b) {
var sa = parseInt(a.getAttribute('data-sort'), 10); if (isNaN(sa)) sa = 999;
var sb = parseInt(b.getAttribute('data-sort'), 10); if (isNaN(sb)) sb = 999;
return sa - sb;
});
}
var n = base.length;
var COPIES = n >= 3 ? 3 : (n === 2 ? 7 : 1);
var items = [];
for (var c = 0; c < COPIES; c++) {
base.forEach(function (node) {
var clone = node.cloneNode(true);
track.appendChild(clone);
items.push(clone);
});
}
var active = n * Math.floor(COPIES / 2);
var animating = false;
var visible = false;
function rvcAttach(v) {
if (v.__rvcAttached === true) return;
var s = v.querySelector('source');
if (s && v.dataset.src) s.setAttribute('src', v.dataset.src);
v.__rvcAttached = true;
v.setAttribute('preload', 'auto');
try { v.load(); } catch (e) {}
}
function rvcDetach(v) {
if (v.__rvcAttached === false) return;
var s = v.querySelector('source');
if (s) {
if (!v.dataset.src && s.getAttribute('src')) v.dataset.src = s.getAttribute('src');
s.removeAttribute('src');
}
v.removeAttribute('src');
v.__rvcAttached = false;
try { v.load(); } catch (e) {}
}
function playManage() {
var nextIdx = active + 1, prevIdx = active - 1;
items.forEach(function (it, idx) {
var v = it.querySelector('video'); if (!v) return;
if (idx === active) {
rvcAttach(v);
v.muted = true;
v.autoplay = true; v.setAttribute('autoplay', '');
var p = v.play();
if (p && p.catch) p.catch(function () {
v.addEventListener('canplay', function () { v.play().catch(function () {}); }, { once: true });
});
} else if (idx === nextIdx || idx === prevIdx) {
rvcAttach(v);
v.autoplay = false; v.removeAttribute('autoplay');
if (!v.paused) v.pause();
} else {
v.autoplay = false; v.removeAttribute('autoplay');
if (!v.paused) v.pause();
rvcDetach(v);
}
});
}
function center(animate) {
var vpW = viewport.clientWidth;
var x = vpW / 2 - (active * (W + GAP) + W / 2);
track.style.transition = animate ? 'transform .45s cubic-bezier(.2,.7,.2,1)' : 'none';
track.style.transform = 'translateX(' + x + 'px)';
items.forEach(function (it, i) { it.classList.toggle('is-active', i === active); });
var capEl = root.querySelector('[data-rvc-caption]');
if (capEl) capEl.textContent = items[active] ? (items[active].getAttribute('data-caption') || '') : '';
playManage();
}
function normalize() {
var lo = n, hi = n * (COPIES - 1);
if (COPIES > 1 && (active < lo || active >= hi)) {
items.forEach(function (it) { var v = it.querySelector('video'); if (v) v.muted = true; });
root.querySelectorAll('[data-rvc-sound]').forEach(function (b) { b.classList.remove('is-live'); });
active = n * Math.floor(COPIES / 2) + (((active % n) + n) % n);
center(false);
}
}
function setActive(i, animate) { active = i; animating = animate; center(animate); if (!animate) normalize(); }
function move(d) { setActive(active + d, true); }
items.forEach(function (it, idx) {
var v = it.querySelector('video');
if (v) {
v.muted = true; v.loop = true; v.setAttribute('playsinline', '');
v.style.cssText = 'width:100%;height:100%;object-fit:cover;display:block';
rvcDetach(v);
var pst = it.querySelector('.rvc__poster');
if (pst) pst.style.cssText = 'position:absolute;inset:0;width:100%;height:100%;object-fit:cover;z-index:2;pointer-events:none;transition:opacity .2s ease';
function hidePoster() { it.classList.add('is-playing'); if (pst) pst.style.opacity = '0'; }
function showPoster() { it.classList.remove('is-playing'); if (pst) pst.style.opacity = '1'; }
v.addEventListener('playing', hidePoster);
v.addEventListener('timeupdate', function () { if (v.currentTime > 0) hidePoster(); });
v.addEventListener('pause', showPoster);
v.addEventListener('emptied', showPoster);
}
it.addEventListener('click', function (e) {
if (e.target.closest && e.target.closest('[data-rvc-sound]')) return;
if (idx !== active) setActive(idx, true);
});
var sb = it.querySelector('[data-rvc-sound]');
if (sb) {
sb.addEventListener('click', function (e) {
e.stopPropagation();
var vid = it.querySelector('video');
var turnOn = vid.muted;
items.forEach(function (o) { var ov = o.querySelector('video'); if (ov) ov.muted = true; });
root.querySelectorAll('[data-rvc-sound]').forEach(function (b) { b.classList.remove('is-live'); });
if (turnOn) { vid.muted = false; sb.classList.add('is-live'); }
});
}
});
track.addEventListener('transitionend', function (e) {
if (e.propertyName === 'transform' && animating) { animating = false; normalize(); }
});
var prev = root.querySelector('[data-rvc-prev]'), nxt = root.querySelector('[data-rvc-next]');
if (prev) prev.addEventListener('click', function () { move(-1); });
if (nxt) nxt.addEventListener('click', function () { move(1); });
window.addEventListener('resize', function () { center(false); });
center(false);
if ('IntersectionObserver' in window) {
var io = new IntersectionObserver(function (entries) {
entries.forEach(function (e) {
visible = e.isIntersecting;
if (visible && items[active]) {
var lv = items[active].querySelector('video');
if (lv) { try { lv.currentTime = 0; } catch (er) {} }
}
playManage();
});
}, { threshold: 0.15, rootMargin: '0px 0px -10% 0px' });
io.observe(root);
} else {
visible = true;
playManage();
}
function kick() { playManage(); }
['touchstart', 'pointerdown', 'click', 'scroll', 'keydown'].forEach(function (ev) {
window.addEventListener(ev, kick, { once: true, passive: true });
});
}
function initAll() { document.querySelectorAll('[data-rvc]').forEach(init); }
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
else initAll();
document.addEventListener('shopify:section:load', initAll);
})();

  } catch(e) { console.error(e); }
})();
})();
